import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "../context/I18nContext";
import "./ComingSoon.css";

export default function ComingSoon({ pageTitle, message, showPath }) {
  const location = useLocation();
  const { t } = useTranslation();

  const title = pageTitle ? pageTitle : t("comingSoon.defaultTitle");

  const description = message ? message : t("comingSoon.defaultDescription");

  const pathInfo = showPath ? location.pathname : null;

  return (
    <main className="coming-soon">
      <div className="coming-soon__card" role="alert">
        <span className="coming-soon__badge">{t("comingSoon.badge")}</span>
        <h1 className="coming-soon__title">{title}</h1>
        <p className="coming-soon__lead">{description}</p>
        {pathInfo ? (
          <p className="coming-soon__path">
            {t("comingSoon.pathNotReady", { path: pathInfo })}
          </p>
        ) : null}
        <div className="coming-soon__actions">
          <Link to="/" className="btn primary">
            {t("comingSoon.backHome")}
          </Link>
          <Link to="/contact" className="btn ghost">
            {t("comingSoon.contactUs")}
          </Link>
        </div>
      </div>
    </main>
  );
}
